import type { Abi } from "viem";

export const ETHRegistrar = [
  {
    inputs: [
      { internalType: "address", name: "owner_", type: "address" },
      { internalType: "contract IHCAFactoryBasic", name: "hcaFactory", type: "address" },
      { internalType: "contract IPermissionedRegistry", name: "ethRegistry", type: "address" },
      { internalType: "address", name: "beneficiary", type: "address" },
      { internalType: "contract IRentPriceOracle", name: "oracle", type: "address" },
      { internalType: "uint64", name: "gracePeriod", type: "uint64" },
      { internalType: "uint64", name: "minCommitmentAge", type: "uint64" },
      { internalType: "uint64", name: "maxCommitmentAge", type: "uint64" },
      { internalType: "uint64", name: "minRegisterDuration", type: "uint64" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "commitment", type: "bytes32" },
      { internalType: "uint64", name: "validFrom", type: "uint64" },
      { internalType: "uint64", name: "blockTimestamp", type: "uint64" },
    ],
    name: "CommitmentTooNew",
    type: "error",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "commitment", type: "bytes32" },
      { internalType: "uint64", name: "validTo", type: "uint64" },
      { internalType: "uint64", name: "blockTimestamp", type: "uint64" },
    ],
    name: "CommitmentTooOld",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint64", name: "duration", type: "uint64" },
      { internalType: "uint64", name: "minDuration", type: "uint64" },
    ],
    name: "DurationTooShort",
    type: "error",
  },
  { inputs: [], name: "InvalidOwner", type: "error" },
  { inputs: [], name: "MaxCommitmentAgeTooLow", type: "error" },
  {
    inputs: [{ internalType: "string", name: "label", type: "string" }],
    name: "NameNotAvailable",
    type: "error",
  },
  {
    inputs: [{ internalType: "string", name: "label", type: "string" }],
    name: "NameNotRenewable",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "token", type: "address" }],
    name: "SafeERC20FailedOperation",
    type: "error",
  },
  {
    inputs: [{ internalType: "bytes32", name: "commitment", type: "bytes32" }],
    name: "UnexpiredCommitmentExists",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: "bytes32", name: "commitment", type: "bytes32" }],
    name: "CommitmentMade",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "tokenId", type: "uint256" },
      { indexed: false, internalType: "string", name: "label", type: "string" },
      { indexed: false, internalType: "address", name: "owner", type: "address" },
      { indexed: false, internalType: "contract IRegistry", name: "subregistry", type: "address" },
      { indexed: false, internalType: "address", name: "resolver", type: "address" },
      { indexed: false, internalType: "uint64", name: "duration", type: "uint64" },
      { indexed: false, internalType: "contract IERC20", name: "paymentToken", type: "address" },
      { indexed: true, internalType: "bytes32", name: "referrer", type: "bytes32" },
      { indexed: false, internalType: "uint256", name: "base", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "premium", type: "uint256" },
    ],
    name: "NameRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "tokenId", type: "uint256" },
      { indexed: false, internalType: "string", name: "label", type: "string" },
      { indexed: false, internalType: "uint64", name: "duration", type: "uint64" },
      { indexed: false, internalType: "uint64", name: "newExpiry", type: "uint64" },
      { indexed: false, internalType: "contract IERC20", name: "paymentToken", type: "address" },
      { indexed: true, internalType: "bytes32", name: "referrer", type: "bytes32" },
      { indexed: false, internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "NameRenewed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "previousOwner", type: "address" },
      { indexed: true, internalType: "address", name: "newOwner", type: "address" },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract IRentPriceOracle",
        name: "oracle",
        type: "address",
      },
    ],
    name: "RentPriceOracleUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "BENEFICIARY",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ETH_REGISTRY",
    outputs: [{ internalType: "contract IPermissionedRegistry", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "GRACE_PERIOD",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "HCA_FACTORY",
    outputs: [{ internalType: "contract IHCAFactoryBasic", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_COMMITMENT_AGE",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MIN_COMMITMENT_AGE",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MIN_REGISTER_DURATION",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MIN_RENEW_DURATION",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "commitment", type: "bytes32" }],
    name: "commit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "commitment", type: "bytes32" }],
    name: "commitmentAt",
    outputs: [{ internalType: "uint64", name: "commitTime", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "label", type: "string" },
      { internalType: "uint64", name: "duration", type: "uint64" },
      { internalType: "contract IERC20", name: "paymentToken", type: "address" },
    ],
    name: "getRegisterPrice",
    outputs: [
      { internalType: "uint256", name: "base", type: "uint256" },
      { internalType: "uint256", name: "premium", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "label", type: "string" },
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "uint64", name: "duration", type: "uint64" },
      { internalType: "contract IERC20", name: "paymentToken", type: "address" },
    ],
    name: "rentPrice",
    outputs: [
      { internalType: "uint256", name: "base", type: "uint256" },
      { internalType: "uint256", name: "premium", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "label", type: "string" }],
    name: "getRemainingGracePeriod",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "label", type: "string" },
      { internalType: "uint64", name: "duration", type: "uint64" },
      { internalType: "contract IERC20", name: "paymentToken", type: "address" },
    ],
    name: "getRenewPrice",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "label", type: "string" }],
    name: "isAvailable",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "label", type: "string" }],
    name: "isRenewable",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "label", type: "string" },
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "bytes32", name: "secret", type: "bytes32" },
      { internalType: "contract IRegistry", name: "subregistry", type: "address" },
      { internalType: "address", name: "resolver", type: "address" },
      { internalType: "uint64", name: "duration", type: "uint64" },
      { internalType: "bytes32", name: "referrer", type: "bytes32" },
    ],
    name: "makeCommitment",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "label", type: "string" },
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "bytes32", name: "secret", type: "bytes32" },
      { internalType: "contract IRegistry", name: "subregistry", type: "address" },
      { internalType: "address", name: "resolver", type: "address" },
      { internalType: "uint64", name: "duration", type: "uint64" },
      { internalType: "contract IERC20", name: "paymentToken", type: "address" },
      { internalType: "bytes32", name: "referrer", type: "bytes32" },
    ],
    name: "register",
    outputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "label", type: "string" },
      { internalType: "uint64", name: "duration", type: "uint64" },
      { internalType: "contract IERC20", name: "paymentToken", type: "address" },
      { internalType: "bytes32", name: "referrer", type: "bytes32" },
    ],
    name: "renew",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rentPriceOracle",
    outputs: [{ internalType: "contract IRentPriceOracle", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "contract IRentPriceOracle", name: "oracle", type: "address" }],
    name: "setRentPriceOracle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes4", name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const satisfies Abi;
